<template>
  <div>

    <div class="submission-details">
      <div class="container">
        <div :class="showActions ? 'row' : ''">
          <div :class="pageTitleClass">
            <suffix v-if="$feature.isOn('see_underlying_properties')" >
              <button class="btn-icon blue" @click="showSeeUnderlyingPropertiesModal">
                <icon class="inspection"></icon>
                <span class="sr-only">See Underling Properties</span>
              </button>
            </suffix>
            <underlying-properties-modal
              @toggle-modal="hideModal(vueModalID.seeUnderlyingProperties)"
              :object-model-entry="selectedObjectModelEntry"
              :object-model="selectedDetailView.objectModel"
              v-if="modalStateFor(vueModalID.seeUnderlyingProperties).isVisible"
              :state="modalStateFor(vueModalID.seeUnderlyingProperties)"
              :index="vueModalID.seeUnderlyingProperties"
            ></underlying-properties-modal>
            <detail-view-content-element-base
              :content-element="pageTitleElement"
              :object-model-entry="entry"
            ></detail-view-content-element-base>
          </div>
          <div class="col-12 col-md-3" v-if="showActions">
            <detail-view-content-element-base
              :content-element="actionsElement"
              :is-in-edit-mode="isInEditMode"
              :object-model-entry="entry"
            ></detail-view-content-element-base>
          </div>

        </div>
        <div>
          <detail-view-content-element-base v-if="pageSubTitleElement.label_title"
                                            :content-element="pageSubTitleElement"
                                            :object-model-entry="entry"
          ></detail-view-content-element-base>
        </div>
        <div v-for="modelProperty in additionalPropertyElements" class="inline-parent">
          <detail-view-content-element-base
            :content-element="modelProperty"
            :object-model-entry="entry"
          ></detail-view-content-element-base>
        </div>

        <tab-container
          v-if="hasTabs"
          :is-in-edit-mode="isInEditMode"
        ></tab-container>
        <a v-if="showReturnToDetailViewLink" :href="returnToDetailViewLink" class="btn-link">
          <icon glyph="arrow-chevron" direction="left" tag="small" aria-hidden="true"></icon>
          Return
        </a>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
  import Vue from "vue";
  import selectedMixin from "../mixins/selectedMixin";
  import DetailViewLayoutElementTabContainer from "./detail-view-layout-element-tab-container.vue"
  import {mapState} from "vuex";
  import {DetailViewMode} from "../enums/detailViewMode";
  import ContentElementComponent from "./content-element-component.vue";
  import UnderlyingPropertiesModal from "~/components/experimental/see-underlying-properties-modal.vue"
  import isOneStop from "~/mixins/isOneStop";
  import {RouteHelper} from "~/helpers/routeHelper";
  import {Route} from "~/enums/route";
  import breadcrumbMixin from "../mixins/breadcrumbMixin";
  export default Vue.extend({
    extends: ContentElementComponent,
    mixins: [selectedMixin, isOneStop, breadcrumbMixin],
    components: {
      'tab-container': DetailViewLayoutElementTabContainer,
      UnderlyingPropertiesModal
    },
    props: {
      hideTabs: {
        type: Boolean,
        default: false
      },
    },
    methods:{
      showSeeUnderlyingPropertiesModal(){
        this.showModal(this.vueModalID.seeUnderlyingProperties)
      }
    },
    computed: {
      objectModel() {
        return this.selectedDetailView.object_model
      },
      pageTitleClass() {
        return {
          "col": this.showActions,
          "inline-parent": true
        }
      },
      pageTitleElement() {
        return this.contentElement.contentElementsArray[0];
      },
      showActions() {
        return this.contentElement.display_actions && this.actionsElement.contentElementsArray.length > 0;
      },
      pageSubTitleElement() {
        return this.contentElement.contentElementsArray[2];
      },
      actionsElement() {
        return this.contentElement.contentElementsArray[1];
      },
      additionalPropertyElements() {
        return this.contentElement.contentElementsArray.slice(3);
      },
      hasTabs(): boolean {
        return !this.hideTabs && this.detailViewMode === DetailViewMode.Default && this.selectedDetailView.tabBreaks.length > 0;
      },
      returnToDetailViewLink(): string {
        const routeEnum = this.isPreview ? Route.previewDetailView : Route.detailView;
        const namedWildcardOptions = [
          { wildcard: ":id", modelOrId: this.selectedPublishedDetailView.detail_view_id },
          { wildcard: ":entry_id", modelOrId: this.selectedObjectModelEntry.id }
        ]
        const query = {
          bc: this.currentBreadcrumbs?.slice(0, this.currentBreadcrumbs.length - 1)
        }
        return RouteHelper.path({ route: routeEnum, namedWildcardOptions, query: query });
      },
      showReturnToDetailViewLink(): boolean {
        return this.hideTabs && this.selectedPublishedDetailView && this.selectedObjectModelEntry
      },
      ...mapState('detailViewStore', ['detailViewMode'])
    }

  });
</script>